
export function setCurrencyYear(state, data) {
  state.currencyYear = data
}




